import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import playButton from 'assets/svgs/play-button.svg';

type ActivityPlayButtonOverlayProps = {
  onOverlayClick?: () => void;
};

const translateActivity = (key) => translate('activities', key);

const ActivityPlayButtonOverlay: React.FC<ActivityPlayButtonOverlayProps> = ({
  onOverlayClick,
}) => {
  const onPlayButtonAction = (e: React.MouseEvent | React.KeyboardEvent | React.TouchEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.keyCode == 32) onOverlayClick?.();
  };
  const classes = styles();

  return (
    <div className={classes.overlay}>
      <div
        className={classes.playButtonContainer}
        onClick={(e) => {
          onPlayButtonAction(e);
          onOverlayClick?.();
        }}
        onTouchEnd={(e) => {
          onPlayButtonAction(e);
          onOverlayClick?.();
        }}
        tabIndex={-1}
      >
        <div
          aria-label={translateActivity('Play')}
          className={classes.playButton}
          onClick={(e) => {
            onPlayButtonAction(e);
            onOverlayClick?.();
          }}
          onKeyDown={(e) => {
            onPlayButtonAction(e);
            onKeyDown(e);
          }}
          role="button"
          tabIndex={0}
        >
          <img alt={translateActivity('Play')} src={playButton} />
        </div>
      </div>
    </div>
  );
};

const styles = makeStyles(() => ({
  overlay: {
    backgroundColor: 'hsla(0, 0%, 98%, 0.5)',
    height: '100%',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100%',
    zIndex: 1000,
  },
  playButton: {
    backgroundColor: 'transparent',
    display: 'flex',
    cursor: 'pointer',
    flex: 'inherit',
    flexDirection: 'column',
    height: 'auto',
    margin: 'auto auto',
    width: '140px',
  },

  playButtonContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
}));

export default ActivityPlayButtonOverlay;
